import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { addEditInvoice } from "../store/api/Invoice";
import { Button, Modal, Table } from "react-bootstrap";
import { Fragment, useCallback, useEffect, useState } from "react";
import { CheckLg, DashCircle, List } from "react-bootstrap-icons";
import NewNumberInput from "../../Components/NewNumberInput";
import { keyIsLetterOrNumber } from "../../store/api/CommonFunctions";
import ModalSearchStorage from "../../Components/Modals/ModalSearchStorage";
import Loader from "react-loader-spinner";

export default function ModalConvertToFormalInvoice(props) {
    const history = useHistory();
    const [isPending, setIsPending] = useState(false);
    const dispatch = useDispatch();
    const { handleSubmit } = useForm();
    const { popData, setPopData, parentInvoiceID } = props;
    const [submitError, setError] = useState({});
    const [selectedStorage, selectStorage] = useState({});
    const { show, invoiceDetails, invoiceType, customerID, customerCat } = popData;
    const [details, setDetails] = useState(invoiceDetails);
    const [popStorage, setPopStorage] = useState({ show: false });
    const hasStorage = details && details.some(d => Number(d.StorageID) > 0);
    function closeModal() {
        setPopData({ show: false });
    }
    function onChangePrice(value, detail, name) {
        if (!value || value === '') {
            value = '0';
        }
        const dtl = details.find(d => d.ID === detail.ID);
        dtl[name] = Number(value);
        switch (name) {
            case "DiscountPercent":
                if (dtl.DiscountPercent > 100) {
                    dtl.DiscountPercent = 100;
                }
                dtl.Discount = detail[name] / 100 * dtl.TotalPrice;
                break;
            case "Discount":
                if (dtl.Discount > dtl.TotalPrice) {
                    dtl.Discount = dtl.TotalPrice;
                }
                if (dtl.TotalPrice === 0) {
                    dtl.Discount = 0;
                }
                else {
                    dtl.DiscountPercent = Number(parseFloat(dtl.Discount / dtl.TotalPrice * 100).toFixed(2));
                }
                break;
            default:
                break;

        }
        if (!dtl.Tax) {
            dtl.Tax = 0;
        }
        dtl.Tax = (dtl.TotalPrice - dtl.Discount) * dtl.TaxPercent / 100;
        dtl.PureTotalPrice = dtl.TotalPrice - dtl.Discount + dtl.Tax;
        setDetails([...details]);
    }
    const selectText = useCallback((e) => {
        e.target.select();
    })
    function submitInvoice() {
        if(isPending)
        {
            return;
        }
        const hasStorageDetails = details.filter(d => Number(d.StorageID) > 0);
        const er = {};
        if (!hasStorageDetails || hasStorageDetails.length === 0) {
            if (!selectedStorage || !selectedStorage.StorageID || Number(selectedStorage.StorageID) < 1) {
                er.Storage = "انبار مبدا مشخص نشده است";
            }
            details.forEach(d => d.StorageID = selectedStorage.StorageID);
        }
        setError(er);
        if (Object.keys(er).length > 0) {
            return;
        }
        details.forEach(d => d.ID = 0);
        const date = new Date(Date.now());
        const invoice = {
            CustomerCat: customerCat ?? 3,
            CustomerID: customerID,
            IsFormal: true,
            PaymentMethod: 0,
            FreightCharge: 0,
            InvoiceDetailList: details,
            InvoiceType_: invoiceType,
            TaxFee: details.map(d => d.Tax).reduce((a, b) => a + b, 0),
            Discount: details.map(d => d.Discount).reduce((a, b) => a + b, 0),
            InvoiceTotalPrice: details.map(d => d.TotalPrice).reduce((a, b) => a + b, 0),
            ContactDate: date,// date.getFullYear() + "-" + date.getMonth() + "-" + date.getDate(),
            InvoicePureTotalPrice: details.map(d => d.PureTotalPrice).reduce((a, b) => a + b, 0)
        };
        if (parentInvoiceID) {
            invoice.ParentInvoiceID = parentInvoiceID;
        }
        const onSuccess = (res) => {
            // if (res.Invoice) {
            //     const data = { ...res.Invoice };
            //     history.push(`/Sale/Invoice/${invoiceType}/${data.InvoiceID}/true`);
            //     setDetails(null);
            //     setPopData({ show: false });
            // }
            setIsPending(false);
            if (Number(res.Invoice?.InvoiceID) > 0) {
                const data = { ...res.Invoice };
                history.push(`/Sale/Invoice/${invoiceType.replace("Pre", "")}/${data.InvoiceID}/true`);
                setDetails(null);
                setPopData({ show: false });
            }

        }
        setIsPending(true);
        dispatch(addEditInvoice(invoice, onSuccess));
    }
    function showModalStorage(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode)) {
                return;
            }
            e.preventDefault();
        }
        const onSelectStorage = (data) => {
            if (data) {
                selectStorage(data);
            }
        }
        setPopStorage({ show: true, setStorageData: onSelectStorage, value: e.key })
    }
    useEffect(() => {
        if (show && !details) {
            setDetails(invoiceDetails);
        }
    }, [show])
    return (
        <Modal size="lg" show={show} onHide={() => { }}>
            {popStorage.show && <ModalSearchStorage popData={popStorage} setStoragePoup={setPopStorage} />}
            <form readOnly onSubmit={handleSubmit(submitInvoice)}>
                <Modal.Header className="headerStyle">
                    تبدیل به فاکتور رسمی</Modal.Header>
                <Modal.Body className="bodyStyle">
                    {show &&
                        <Fragment>
                            <Table responsive className="fixedTable zMargin" >
                                <thead>
                                    <tr>
                                        <th style={{ width: "5%" }}>ردیف</th>
                                        {hasStorage && <th style={{ width: "15%" }}>انبار</th>}
                                        <th style={{ width: hasStorage ? "33%" : "43%" }}>مشخصات کالا</th>
                                        <th style={{ width: "9%" }}>% تخفیف</th>
                                        <th style={{ width: hasStorage ? "14%" : "19%" }}>تخفیف</th>
                                        <th style={{ width: "24%" }}>قیمت نهایی به علاوه ارزش افزوده</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(details) &&
                                        details.map((detail, i) =>
                                            <tr key={i} className="resultTableRow">
                                                <td style={{ width: "5%" }} className="tableCell">{i + 1}</td>
                                                {hasStorage && <td style={{ width: "15%" }} className="tableCell">{detail.StorageName}</td>}
                                                <td style={{ width: hasStorage ? "33%" : "43%" }} className="tableCell">
                                                    {detail.ProductName + "-" + detail.ProductModel}
                                                </td>
                                                <td style={{ width: "9%" }} className="tableCell">
                                                    <input type="number" className="tableRowInput" value={detail.DiscountPercent ?? 0} min={0} max={100}
                                                        onChange={e => onChangePrice(e.target.value, detail, "DiscountPercent")} onFocus={selectText} step={0.01} />
                                                </td>
                                                <td style={{ width: hasStorage ? "14%" : "19%" }} className="tableCell">
                                                    <NewNumberInput className="tableRowInput" value={detail.Discount ?? 0} style={{ color: "#ebedee" }}
                                                        onChange={e => onChangePrice(e.target.value, detail, "Discount")} step={0.01} />
                                                </td>
                                                <td style={{ width: "24%" }} className="tableCell">
                                                    <input type="text" className="tableRowInput" disabled value={(detail.PureTotalPrice ?? 0).toLocaleString(navigator.language, { minimumFractionDigits: 0 })} />
                                                </td>
                                            </tr>)
                                    }
                                </tbody>
                            </Table>
                            {!hasStorage &&
                                <div className="col-md-4 form-group">
                                    <label>انبار مبدا</label>
                                    <input type="text" className="form-control" readOnly value={selectedStorage.StorageName ?? ""} onKeyDown={showModalStorage} />
                                    <Button className="btn-input-tiny" onClick={showModalStorage} style={{ left: "4px" }}><List size={16} /></Button>
                                    {submitError.Storage && <small className="errors">{submitError.Storage}</small>}
                                </div>
                            }
                        </Fragment>
                    }
                    {show &&
                        <div className="mt-2">
                            <Button type="submit" className="group-Btn" variant="success" disabled={isPending}>{
                                isPending ?
                                 <Loader type="TailSpin" color="white" width={16} height={16} style={{display:"inline-block"}}/>:
                                <CheckLg />}&nbsp;ثبت فاکتور</Button>
                            <Button className="group-Btn" variant="danger" onClick={closeModal} disabled={isPending}><DashCircle size={16} />&nbsp;انصراف&nbsp;</Button>
                        </div>
                    }
                </Modal.Body>


            </form>
        </Modal>
    )
}